import { IonAlert, IonicSafeString } from "@ionic/react";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import "./AlertComponent.css";

interface AlertInterface {
    showAlert: boolean;
    onDonePressed: () => void;
    buttonDone?: string;
    buttonAltText?: string;
    dismissAlert?: () => void;
    title?: string;
    subTitle?: string;
    description?: string | IonicSafeString;
    showAlternativeButton?: boolean;
    onButtonAltClicked?: () => void;
    confirmButtonClassName?: string;
    testId: string;
}

const AlertComponent: FC<AlertInterface> = ({
    showAlert,
    title = "",
    buttonAltText = "",
    buttonDone,
    description = "",
    dismissAlert,
    onButtonAltClicked,
    onDonePressed,
    showAlternativeButton = false,
    subTitle = "",
    confirmButtonClassName,
    testId,
}) => {
    const { t } = useTranslation();
    const confirmText: string =
        buttonDone ?? (t("help.OnboardingVideo.controls.ok") as string);
    return (
        <IonAlert
            data-testid={testId}
            id={`alert-${testId}`}
            isOpen={showAlert}
            onDidDismiss={dismissAlert}
            header={title}
            subHeader={subTitle}
            message={description}
            buttons={
                showAlternativeButton
                    ? [
                          {
                              text: buttonAltText,
                              handler: onButtonAltClicked,
                              cssClass: "alert-button-cancel",
                          },
                          {
                              text: confirmText,
                              handler: onDonePressed,
                              cssClass: "alert-button-done",
                          },
                      ]
                    : [
                          {
                              text: confirmText,
                              handler: onDonePressed,
                              cssClass: `alert-button-done ${confirmButtonClassName}`,
                          },
                      ]
            }
        />
    );
};

export default AlertComponent;
